import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AccessibilityProvider } from "@/context/AccessibilityContext";
import PublicLayout from "@/components/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import BoardOfDirectors from "@/pages/BoardOfDirectors";
import InitiativePage from "@/pages/InitiativePage";
import Initiatives from "@/pages/Initiatives";
import ChipMat from "@/pages/ChipMat";
import Startups from "@/pages/Startups";
import Careers from "@/pages/Careers";
import Tenders from "@/pages/Tenders";
import Incubate from "@/pages/Incubate";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

export default function App() {
  return (
    <AccessibilityProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/directors" element={<BoardOfDirectors />} />
              <Route path="/board" element={<BoardOfDirectors />} />
              <Route path="/initiatives" element={<Initiatives />} />
              <Route path="/initiatives/:slug" element={<InitiativePage />} />
              <Route path="/chipmat" element={<ChipMat />} />
              <Route path="/startups" element={<Startups />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/tenders" element={<Tenders />} />
              <Route path="/incubate" element={<Incubate />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </AccessibilityProvider>
  );
}
